// extracted by mini-css-extract-plugin
var _1 = "dg3cl";
export { _1 as "base" }
